import React from 'react';
import propTypes from 'prop-types';

export const LocationIcon = ({ size, color, variant }) => {
  const sizeInPixel = `${size}px`;
  return (
    <svg
      width={sizeInPixel}
      height={sizeInPixel}
      className={variant}
      fill={color}
      viewBox="0 0 24 24"
      id="2723fdf8-22cd-4a3e-a5e2-3dd7646800c4"
      data-name="Livello 1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="02f9f2c1-c5f9-4dfd-bbb7-918d15e8e05e" data-name="map pin">
        <path d="M11.9,1a8.6,8.6,0,0,0-8.6,8.6c0,4.35,7.2,12.05,8.42,13.33a0.24,0.24,0,0,0,.35,0c1.22-1.27,8.42-9,8.42-13.33A8.6,8.6,0,0,0,11.9,1Zm0,11.67A3.07,3.07,0,1,1,15,9.6,3.07,3.07,0,0,1,11.9,12.67Z" />
      </g>
    </svg>
  );
};
LocationIcon.propTypes = {
  size: propTypes.number,
  color: propTypes.string,
  variant: propTypes.string,
};
LocationIcon.defaultProps = {
  size: 18,
  color: 'black',
  varient: '',
};
